import { useState } from 'react';
import { IoIosAddCircle } from 'react-icons/io';
import TableTwo from './TableTwo';

const Tertiary = ({ tertiary, setTertiary, tertiaryLevel, setTertiaryLevel, course, setCourse, tertiaryYear, setTertiaryYear}) => {
    const [error, setError] = useState(null);

    const addTertiary = () => {
        setError(null);

        for (let i = 0; i < tertiary.length; i++) {
            if(tertiary[i].course === course)  {
                setError('Sorry, you cannot duplicate course.')
                return;
            }         
        }

        if(tertiaryLevel !== '' && course !== '' && tertiaryYear !== '') {
            let data = {
                tertiaryLevel,
                course,
                tertiaryYear

            }
            setTertiary([...tertiary, data]);
            setTertiaryYear('');
            setCourse('');
            setTertiaryLevel('');
        } else {
            setError('Please provide all the details.');

        }
    }

    return ( 
        <>
            <h5 className="title is-size-5-touch has-text-weight-bold mt-6 mb-2 grey-text text-darken-3">Tertiary / Polytechnic / College Examination Results</h5>
            <div className="divider mb-5"></div>
            <div className="row">
                <div className="input-field col s12 m5">
                    <input id="levelAtained" type="text" onChange={(e) => setTertiaryLevel(e.target.value)} value={tertiaryLevel} />
                    <label htmlFor="levelAtained" className="active">Level Attained: (e.g NC)</label>
                </div>
                <div className="input-field col s12 m5">
                    <input id="courseTitle" type="text" onChange={(e) => setCourse(e.target.value)} value={course} />
                    <label htmlFor="courseTitle" className="active">Course Title: </label>
                </div>
                <div className="input-field col s12 m2">
                    <input id="yearTertiary" type="text" onChange={(e) => setTertiaryYear(e.target.value)} value={tertiaryYear} />
                    <label htmlFor="yearTertiary" className="active">Year Obtained: </label>
                </div>
            </div>
            {
                error && <p className="red-text text-darken-3">{error}</p>
            }
            <div className="control">
                <div className="button is-success mt-5"
                    onClick={addTertiary}
                >
                    <span className="icon">
                        <IoIosAddCircle size="1.25rem" color="white"/>
                    </span>
                    <span className="white-text">Add </span>
                </div>
            </div>
            {
                tertiary.length !== 0 && <TableTwo tertiary={tertiary} setTertiary={setTertiary} />
            }
            <div className="mt-4 mb-4">
                <p className="grey-text text-darken-2"><span className="has-text-weight-bold">NB: </span> For NC / HND Applications only.</p>
            </div>
        </>
     );
}
 
export default Tertiary;